/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/WorkspaceMindmapNode', 'model/WorkspaceMindmapNodePaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/WorkspaceMindmapNode'), require('../model/WorkspaceMindmapNodePaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkspaceMindmapNodeApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.WorkspaceMindmapNode, root.ForStractionServiceApi.WorkspaceMindmapNodePaginationSlice);
  }
}(this, function(ApiClient, WorkspaceMindmapNode, WorkspaceMindmapNodePaginationSlice) {
  'use strict';

  /**
   * WorkspaceMindmapNode service.
   * @module api/WorkspaceMindmapNodeApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new WorkspaceMindmapNodeApi. 
   * @alias module:api/WorkspaceMindmapNodeApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the workspaceMindmapNodeAddPut operation.
     * @callback module:api/WorkspaceMindmapNodeApi~workspaceMindmapNodeAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/WorkspaceMindmapNode} body 
     * @param {module:api/WorkspaceMindmapNodeApi~workspaceMindmapNodeAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.workspaceMindmapNodeAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workspaceMindmapNodeAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workspaceMindmapNodeAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/WorkspaceMindmapNode/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workspaceMindmapNodeDeleteAllPut operation.
     * @callback module:api/WorkspaceMindmapNodeApi~workspaceMindmapNodeDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/WorkspaceMindmapNodeApi~workspaceMindmapNodeDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workspaceMindmapNodeDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workspaceMindmapNodeDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workspaceMindmapNodeDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/WorkspaceMindmapNode/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workspaceMindmapNodeDeleteGet operation.
     * @callback module:api/WorkspaceMindmapNodeApi~workspaceMindmapNodeDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/WorkspaceMindmapNodeApi~workspaceMindmapNodeDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workspaceMindmapNodeDeleteGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workspaceMindmapNodeDeleteGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workspaceMindmapNodeDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/WorkspaceMindmapNode/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workspaceMindmapNodeEditPut operation.
     * @callback module:api/WorkspaceMindmapNodeApi~workspaceMindmapNodeEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/WorkspaceMindmapNode} body 
     * @param {module:api/WorkspaceMindmapNodeApi~workspaceMindmapNodeEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workspaceMindmapNodeEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workspaceMindmapNodeEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workspaceMindmapNodeEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/WorkspaceMindmapNode/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workspaceMindmapNodeLoadGet operation.
     * @callback module:api/WorkspaceMindmapNodeApi~workspaceMindmapNodeLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkspaceMindmapNode} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.translate  (default to false)
     * @param {module:api/WorkspaceMindmapNodeApi~workspaceMindmapNodeLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkspaceMindmapNode}
     */
    this.workspaceMindmapNodeLoadGet = function(_4SAPIAppID, entityID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workspaceMindmapNodeLoadGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workspaceMindmapNodeLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID,
        'translate': opts['translate']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkspaceMindmapNode;

      return this.apiClient.callApi(
        '/WorkspaceMindmapNode/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workspaceMindmapNodeLoadMindmapSliceGet operation.
     * @callback module:api/WorkspaceMindmapNodeApi~workspaceMindmapNodeLoadMindmapSliceGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkspaceMindmapNodePaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadMindmapSlice
     * @param {String} _4SAPIAppID 
     * @param {Integer} mindmapID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.slicingOrder  (default to 0)
     * @param {module:api/WorkspaceMindmapNodeApi~workspaceMindmapNodeLoadMindmapSliceGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkspaceMindmapNodePaginationSlice}
     */
    this.workspaceMindmapNodeLoadMindmapSliceGet = function(_4SAPIAppID, mindmapID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workspaceMindmapNodeLoadMindmapSliceGet";
      }

      // verify the required parameter 'mindmapID' is set
      if (mindmapID == undefined || mindmapID == null) {
        throw "Missing the required parameter 'mindmapID' when calling workspaceMindmapNodeLoadMindmapSliceGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'mindmapID': mindmapID,
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'slicingOrder': opts['slicingOrder']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkspaceMindmapNodePaginationSlice;

      return this.apiClient.callApi(
        '/WorkspaceMindmapNode/loadMindmapSlice', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
